import { SentinelWorkspace } from '@/modules/sentinel-workspace/sentinel-workspace';

export default function SentinelWorkspaceRoute() {
  return (
    <div data-sentinel-workspace-page className="flex h-[calc(100dvh-3rem)] md:h-screen w-full overflow-hidden">
      <SentinelWorkspace />
    </div>
  );
}
